module.exports = __webpack_public_path__ + "static/img/meh2.628f7fb.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/meh2.png
// module id = 0545
// module chunks = 1